import { render, staticRenderFns } from "./NetWorthSummary.vue?vue&type=template&id=af064f56&"
import script from "./NetWorthSummary.vue?vue&type=script&lang=js&"
export * from "./NetWorthSummary.vue?vue&type=script&lang=js&"
import style0 from "./NetWorthSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports